export function search(tree, name) {
    let isGet = false;
    let retNode = tree;

    function deepSearch(tree, name) {
        for (var i = 0; i < tree.length; i++) {
            tree[i].id = tree[i].data.id;
            if ((tree[i].data.name.indexOf(name) != -1) || tree[i].data.name == name || isGet) {
                isGet || (retNode = tree[i]);
                isGet = true;
                break;
            }
            if (tree[i].children && tree[i].children.length > 0) {
                deepSearch(tree[i].children, name);
            } else if (tree[i].children && (tree[i].children == [] || tree[i].children == '')) {
                delete tree[i].children
            }
        }
    }
    deepSearch(tree, name);
    retNode != null ? retNode.data : null;
    return retNode;
}
export function tree(trees,id){
    let isGet =false;
    let retNode = trees;
    function deepSearch(trees,id){
        for (var i=0; i<trees.length;i++){   
            // if ((trees[i].data.name.indexOf(name)!=-1) || trees[i].data.name == name || isGet) {
            //     isGet || (retNode = trees[i]);
            //     isGet = true;
            //     break;
            // }
            if(trees[i].data&&trees[i].data.id==id){                
                trees[i].isDisabled = true
            }   
            if (trees[i].children && trees[i].children.length > 0) {
                deepSearch(trees[i].children, id);
            }else if(trees[i].children&& ( trees[i].children==[]||trees[i].children=='')){
                delete trees[i].children
            }
        }
    }
    deepSearch(trees, id);
    retNode != null ? retNode.data : null;
    return retNode;
}
export function formatTree(tree) {
    function deepSearch(tree, name) {
        for (var i = 0; i < tree.length; i++) {
            if (tree[i].children && tree[i].children.length > 0) {
                deepSearch(tree[i].children, name);
            } else if (tree[i].children && (tree[i].children == [] || tree[i].children == '')) {
                delete tree[i].children
            }
        }
    }
    deepSearch(tree, name);
}

export function courseTree(tree, id, val) {
    let isGet = false;
    let retNode = tree;

    function deepSearch(tree, id, val) {
        if (val == '') {
            for (var i = 0; i < tree.length; i++) {
                if ((tree[i].data.id.indexOf(id) != -1) || tree[i].data.id == id || isGet) {
                    isGet || (retNode = tree[i]);
                    // tslint:disable-next-line:no-unused-expression
                    isGet = true;
                    break;
                }
                if (tree[i].children && tree[i].children.length > 0) {
                    deepSearch(tree[i].children, id);
                }
            }
        } else if (val == 'next') {
            for (var i = 0; i < tree.length; i++) {
                if ((tree[i].data.id.indexOf(id) != -1) || tree[i].data.id == id || isGet) {
                    if (i != tree.length - 1) {
                        isGet || (retNode = tree[i]);
                        // tslint:disable-next-line:no-unused-expression
                        isGet = true;
                        break;
                    }
                }
                if (tree[i].children && tree[i].children.length > 0) {
                    deepSearch(tree[i].children, id);
                }
            }
        } else if (val == 'prev') {
            for (var i = 0; i < tree.length; i++) {
                if ((tree[i].data.id.indexOf(id) != -1) || tree[i].data.id == id || isGet) {
                    if (i != 0) {
                        isGet || (retNode = tree[i]);
                        // tslint:disable-next-line:no-unused-expression
                        isGet = true;
                        break;
                    }
                }
                if (tree[i].children && tree[i].children.length > 0) {
                    deepSearch(tree[i].children, id);
                }
            }
        }
    }
    deepSearch(tree, id, val);
    retNode != null ? retNode.data : null;
    return retNode;
}



export function addressTree(tree, label) {
    let isGet = false;
    let retNode = tree;

    function deepSearch(tree, label) {
        for (var i = 0; i < tree.length; i++) {
            if ((tree[i].label.indexOf(label) != -1) || tree[i].label == label || isGet) {
                isGet || (retNode = tree[i]);
                isGet = true;
                break;
            }
        }
    }
    deepSearch(tree, label);
    retNode != null ? retNode.data : null;
    return retNode;
}